module.exports = __webpack_public_path__ + "img/1.fb4fa444.png";